import { IApplicationState } from '../../types/redux';

// Будет переписан в задаче CD-144919, когда будут добавлены реальные данные
/* istanbul ignore next */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getTransportAccessibilitySource = (state: IApplicationState): string => {
  const { transportAccessibilityRate } = state.newbuilding;

  return transportAccessibilityRate.sourceUrl;
};
